(function () {
  const block = {
    $blocks: document.querySelectorAll('.recent_results'),
    init() {
      if (this.$blocks.length) {
        this.$blocks
          .forEach($block => {
            if ($block.classList.contains('template_slider')
            || $block.classList.contains('template_slider_new')
            || $block.classList.contains('template_slider_2026')) {
              PubSub.publish('embla.init', {
                name: 'recent-results-carousel',
                $els: $block,
                options: {
                  loop: true
                },
                plugins: [
                  EmblaCarouselAutoScroll({
                    speed: 0.7,
                    playOnInit: false,
                    startDelay: 0
                  })
                ]
              });
            }
          });

        this.initTitleCounters();
      }
    },

    initTitleCounters() {
      const $titles = document.querySelectorAll('.recent_results .title[data-animate-number]');

      if (!$titles.length) {
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(({isIntersecting, target}) => {
          if (!isIntersecting || target.animated) {
            return;
          }

          const decimals = target.dataset.finalamount.includes('.')
            ? target.dataset.finalamount.split('.')[1].length
            : 0;
          const animObj = {
            currCount: +target.dataset.startamount
          };

          target.animated = true;

          gsap.to(animObj, {
            currCount: +target.dataset.finalamount,
            duration: 3,
            ease: 'expo.out',
            onUpdate() {
              target.textContent = `${target.dataset.prefix}${Number(animObj.currCount).toLocaleString('en', {
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals
              })}${target.dataset.suffix}`;
            }
          });

          observer.unobserve(target);
        });
      }, {
        threshold: 1
      });

      $titles.forEach($title => {
        observer.observe($title);
      });
    }
  };

  block.init();
})();


